module.exports = __webpack_public_path__ + "img/md6abg_en.21e52002.png";